var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',_vm._l((_vm.deviceInfo),function(item,key,counter){return _c('tr',{key:key,staticClass:"info-item",attrs:{"tabindex":counter},on:{"click":_vm.test}},[_c('td',{staticClass:"key"},[_vm._v(_vm._s(key))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(JSON.stringify(item)))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34fbd239","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InfoDashboard.vue
// module id = null
// module chunks = 